import DataFetcherTemplate from "../hooks/fetchTemplate";
import BlockRightImage from "../components/BlockRightImage";
import BlockImageCabecera from "../components/BlockImageCabecera";
import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";
import SEO from "../components/SEO";
import imgseo from "../img/utplimg.jpg";

function GestionProcesos() {
  const DataDisplay = ({ data }) => (
    <>
      <>
        {data.map((item, index) => (
          <>
            <BlockImageCabecera
              src={item.field_portada}
              title={
                <>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_texto_portada,
                    }}
                  />
                </>
              }
            ></BlockImageCabecera>
            <div className="lightbluebg ">
              <Breadcumbs
                content={
                  <>
                    <NavLink to="/transparencia">Transparencia</NavLink>
                    <span class="material-icons">chevron_right</span>
                    <NavLink to="/gestion-procesos">
                      Gestión de procesos
                    </NavLink>
                  </>
                }
              ></Breadcumbs>

              <div
                className="layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque1,
                }}
              />
            </div>
            <div className="padding bluebg">
              <div
                className="layout8"
                dangerouslySetInnerHTML={{
                  __html: item.field_bloque2,
                }}
              />
            </div>
            <div className="padding">
              <BlockRightImage
                src={item.field_imagen3}
                content={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_bloque3,
                      }}
                    />
                  </>
                }
              ></BlockRightImage>
            </div>
          </>
        ))}
      </>
    </>
  );
  return (
    <>
      <SEO
        title="Gestion de procesos UTPL"
        description="Iniciativa busca garantizar servicios educativos."
        image={imgseo}
        url="https://utpl.edu.ec/gestion-procesos"
      />{" "}
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/services/servicio-gestion-procesos.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
    </>
  );
}

export default GestionProcesos;
